import { render, staticRenderFns } from "./academic_word_feedback.vue?vue&type=template&id=4687a78d&scoped=true&"
import script from "./academic_word_feedback.vue?vue&type=script&lang=js&"
export * from "./academic_word_feedback.vue?vue&type=script&lang=js&"
import style0 from "./academic_word_feedback.vue?vue&type=style&index=0&id=4687a78d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4687a78d",
  null
  
)

export default component.exports